module.exports = __webpack_public_path__ + "img/196.f82716a4.jpg";